<template>
  <div>
    <b-field style="float:left; margin-right:10px" v-if="activeOverlaySelector">
      <b-select @input="overlayLayerChanged" v-model="checkedOverlayLayer" icon="earth">
        <option 
        v-for="(layer, okey) in overlayLayersData"
        :value="okey"
        :key="okey"
        :label="layer.title">
        </option>
      </b-select>
    </b-field>

    <b-field style="float:left">
      <b-select :disabled="this.$store.getters['isComparisonModeActive']" @input="baseLayerChanged" v-model="checkedBaseLayer" icon="checkerboard">
        <optgroup
          v-for="(group, gkey) in baseLayersData"
          :value="gkey"
          :key="gkey"
          :label="$t(gkey)">
            <option 
            v-for="(layer, lkey) in group"
            :value="lkey"
            :key="lkey"
            :label="layer.title">
            </option>
        </optgroup>
      </b-select>
    </b-field>
  </div>
</template>

<script>

export default {
  props: {
    baseLayers: {
      type: Object,
      default: null
    },
    overlayLayers: {
      type: Object,
      default: null
    },
    activeBaseLayer: {
      type: String,
      default: null
    },
    activeOverlayLayer: {
      type: String,
      default: null
    },
    coherenceIntervals: {
      type: Object,
      default: null
    },
    position: {
      type: String,
      default: null
    },
    onBaseLayerChange: {
      type: Function,
      default: () => {}
    },
    onOverlayLayerChange: {
      type: Function,
      default: () => {}
    },
    activeOverlaySelector: {
      type: Boolean,
      default: true
    },
  },
  data () {
    return {
      checkedBaseLayer: this.activeBaseLayer || '',
      checkedOverlayLayer: this.activeOverlayLayer || '',
      baseLayersData: this.groupBaseLayers(),
      overlayLayersData: this.overlayLayers || {}
    }
  },
  methods: {
    baseLayerChanged () {
      this.onBaseLayerChange(this.checkedBaseLayer)
    },
    overlayLayerChanged () {
      this.onOverlayLayerChange(this.checkedOverlayLayer)
    },
    groupBaseLayers () {
      // Create object with different groups of layers: coh6, coh12
      let baseLayersData = {
        rest: {}
      }
      for (const coherence in this.coherenceIntervals) {
        baseLayersData[coherence] = {}
        for (const layer in this.baseLayers) {
          if (this.baseLayers[layer].layerType === coherence) {
            baseLayersData[coherence][layer] = this.baseLayers[layer]
          }
        }
      }
      // Populate the object with the rest of the layers whose type != coh6 or coh12
      const coherenceIntervalsList = Object.keys(this.coherenceIntervals)
      for (const layer in this.baseLayers) {
        if (!coherenceIntervalsList.includes(this.baseLayers[layer].layerType)) {
          baseLayersData.rest[layer] = this.baseLayers[layer]
        }
      }
      // Go over the layer groups and remove empty ones if such exist
      Object.keys(baseLayersData).forEach(function (group) {
        if (Object.keys(baseLayersData[group]).length === 0) {
          delete baseLayersData[group]
        }
      })
      return baseLayersData
    }
  }
}

</script>

<style lang="stylus" scoped>


</style>
